import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';

import SyncAltIcon from '@mui/icons-material/SyncAlt';

const menuItems = [
  {
      label: 'Omnibox JSON Converter',
      description: 'Convert raw Omnibox data',
      icon: <SyncAltIcon sx={{ fontSize: 48 }} />,
      path: '/operations/tools/omnibox-json-converter',
      color: 'grey.800'
    },
    {
      label: 'Omnibox CSV Converter',
      description: 'Convert Omnibox summary CSV files',
      icon: <SyncAltIcon sx={{ fontSize: 48 }} />,
      path: '/operations/tools/omnibox-csv-converter',
      color: 'grey.800'
    },
]

function ToolsLandingPage() {
  const navigate = useNavigate()
  return (
    <Box>

      <Grid container spacing={3}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.label}>
            <Card
              sx={{
                height: '100%',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardActionArea onClick={() => navigate(item.path)} sx={{ height: '100%', p: 2 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      backgroundColor: item.color,
                      display: 'flex', 
                      alignItems: 'center',
                      justifyContent: 'center',
                      mx: 'auto',
                      mb: 2,
                      color: 'white',
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography variant='h6' fontWeight={600} sx={{ mb: 1 }}>
                    {item.label}
                  </Typography>
                  <Typography variant='body2' fontStyle='italic' color='text.secondary'>
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default ToolsLandingPage;